import { z } from "zod";

export const fuelSlotRequestOrderEditSchema = z.object({
  orders: z.array(
    z.object({
      orderId: z.any().optional(),
      dispatchPlace: z.any().optional(),
      chofer: z.any().optional(),
      observations: z.any().optional(),
      URLMaps: z.any().optional(),
      products: z
        .array(
          z.object({
            productId: z.any().optional(),
            tons: z.any().optional(),
          }),
        )
        .min(1),
    }),
  ),
});

export type FuelSlotRequestOrderEditForm = z.infer<
  typeof fuelSlotRequestOrderEditSchema
>;
